import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

import { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

const PublicationNewsLoader = () => (
  <Row width="100%">
    <Col>
      <Box flexDirection="column" p={6}>
        <Skeleton
          height={{ s: '128px', m: '200px', l: '270px', xl: '310px' }}
          isLarge
          mb={4}
          width="100%"
        />
        <Skeleton height={38} isLarge mb={2} width="50%" />
        <Skeleton height={14} mb={4} width="20%" />
        <Skeleton height={2} isLarge mb={4} width="100%" />
        {Array.from({
          length: 3,
        }).map((_, i) => (
          <Skeleton key={i} height={16} isLarge mb={2} width="100%" />
        ))}
        <Skeleton height={16} isLarge width="90%" />
      </Box>
    </Col>
  </Row>
);

export default PublicationNewsLoader;
